module.exports = __webpack_public_path__ + "img/1@2x.dd0f1fdb.jpg";